export default __webpack_public_path__ + "static/media/clap.1132764d.ogg";